export const BRAND = {
    name: "XA Hosting",
    discordUrl: "https://discord.gg/hPsdm8fPhU",
    statusUrl: "https://status.xahosting.com/",
    supportUrl: "/support",
    billingUrl: "https://billing.xahosting.com/",
    clientAreaUrl: "https://billing.xahosting.com/dashboard",
    gamePanelUrl: "https://panel.xahosting.com/",
    deployUrl: "https://billing.xahosting.com/products/", // TODO: replace with Paymenter order URL
    dedicatedUrl: "/dedicated",
    gameHostingUrl: "/game-hosting",
    websitesUrl: "/web-hosting",
};


export const PRICING = {
    pricePerGb: 1.5,
    diskPerGb: 10, // GB NVMe per 1GB RAM
    cpuPercentPerGb: 50, // Pterodactyl CPU limit per 1GB RAM
    backups: { daily: 7, manual: 2 },
    ramMin: 2,
    ramMax: 32,
    ramStep: 2,
};